export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9517.a0ab4888.jpg";